import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

const typeLabel: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
};

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - ${movie.genres.join(" ")}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded-md bg-accent-500 text-primary-950 text-xs font-bold">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-background-50/90 text-foreground-800 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          {movie.region} · {typeLabel[movie.type]}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.genres.join(" / ")}
        </p>
      </div>
    </Link>
  );
}